module.exports = __webpack_public_path__ + "static/img/home-banners31.c894fa9a.jpg";